import { useState } from "react";
import { getAllErrorsAsString, ServicesURL } from "@utils/utilsApi";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { DetailGetInterface } from "../SupplierFormCst/types";

export const useAddEditSupplier = (
  triggetSupplier: (input: any) => any,
  mutate?: any,
) => {
  dayjs.extend(customParseFormat);
  const [openConfirmStatus, setOpenConfirmStatus] = useState<{
    s: StatusEnum;
    message?: string;
  }>();

  const [savedInputForm, setSavedInputForm] = useState(null);
  const [savedDetails, setsavedDetails] = useState<DetailGetInterface[]>([]);

  const onSubmit = async (inputForm: any, details: DetailGetInterface[]) => {
    let newInputForm = {
      sap_code: inputForm.sap_code || null,
      business_name: inputForm?.business_name || null,
      vat_identification_number: inputForm?.vat_identification_number || null,
      fiscal_code: inputForm.fiscal_code || null,
      contact_person_name: inputForm.contact_person_name || null,
      contact_person_email: inputForm.contact_person_email || null,
      notes: inputForm.notes || null,
      details: details.map((detail: any) => {
        return {
          ...detail,
          id: detail.id || null,
          country: detail.country || null,
          province: detail.province || null,
          city: detail.city || null,
          postal_code: detail.postal_code || null,
          address: detail.address || null,
          email: detail.email || null,
          phone: detail.phone || null,
          alternate_phone: detail.alternate_phone || null,
          website: detail.website || null,
        };
      }),
    };

    setSavedInputForm(null);
    setsavedDetails([]);
    setOpenConfirmStatus({ s: StatusEnum.LOADING });

    try {
      await triggetSupplier(newInputForm);
      setOpenConfirmStatus({ s: StatusEnum.OK });
    } catch (error) {
      setOpenConfirmStatus({
        s: StatusEnum.KO,
        message: getAllErrorsAsString(error),
      });
    }
    mutate && mutate(inputForm);
  };

  return {
    onSubmit,
    setOpenConfirmStatus,
    openConfirmStatus,
    savedInputForm,
    savedDetails,
  };
};
